export default "__VITE_ASSET__CCc5zAzJ__"